<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>测算管理</el-breadcrumb-item>
          <el-breadcrumb-item>测算编辑</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="测算信息" name="account">
            <div class="tab-content">
              <el-form
                ref="editForm1"
                :model="model"
                :rules="rules"
                :label-position="labelPosition"
              >
                <el-form-item label="所属城市" label-width="120px">
                  <el-select
                    v-model="model.regionId"
                    :disabled="disabled"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in companyList"
                      :key="item.id"
                      :label="item.region"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="有效时间" label-width="120px">
                  <el-date-picker
                    v-model="time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-row class="card-form">
                  <el-col>
                    <el-card shadow="hover">
                      <div slot="header" class="clearfix">
                        <span>费用设置</span>
                      </div>
                      <div class="dl-box-fee">
                        <el-form-item prop="priceJ" label="尖时">
                          <el-input
                            v-model="model.priceJ"
                            placeholder=""
                            :disabled="disabled"
                          ></el-input>
                          元
                        </el-form-item>
                        <el-form-item prop="priceF" label="峰时">
                          <el-input
                            v-model="model.priceF"
                            placeholder=""
                            :disabled="disabled"
                          ></el-input>
                          元
                        </el-form-item>
                        <el-form-item prop="priceP" label="平时">
                          <el-input
                            v-model="model.priceP"
                            placeholder=""
                            :disabled="disabled"
                          ></el-input>
                          元
                        </el-form-item>
                        <el-form-item prop="priceG" label="谷时">
                          <el-input
                            v-model="model.priceG"
                            placeholder=""
                            :disabled="disabled"
                          ></el-input>
                          元
                        </el-form-item>
                      </div>
                    </el-card>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button
            type="primary"
            :disabled="disabled1"
            @click="submitForm('editForm')"
            >确认保存</el-button
          >
          <el-button plain @click="resetForm">取消返回</el-button>
          <el-button plain @click="submitForms" :disabled="disabled2"
            >下一步</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../js/upload.component.js";
import { AxiosAjax, getCompanyData } from "../../js/axios.config";

export default {
  data() {
    return {
      disabled1: true,
      disabled: true,
      disabled2: true,
      activeName: "account", //当前选项卡
      labelPosition: "right", //表单对齐方式
      modeList: [
        { id: -1, title: "请选择..." },
        { id: 1, title: "充电" },
        { id: 2, title: "放电" },
        { id: 3, title: "空闲" },
      ], //模式列表
      feeList: [
        { id: -1, title: "请选择..." },
        { id: 1, title: "尖时" },
        { id: 2, title: "峰时" },
        { id: 3, title: "平时" },
        { id: 4, title: "谷时" },
      ], //模式列表
      companyList: [], //列表
      seasonList: [
        {
          id: 1,
          season: "非夏季",
          seasonType: "NORMAL",
        },
        {
          id: 2,
          season: "夏季",
          seasonType: "SUMMER",
        },
      ], //季别
      form: {
        startTime: null,
        endTime: null,
      },
      disabled: false,
      time: [],
      model: {
        priceStartTime: "",
        priceEndTime: "",
        regionId: "",
        priceJ: 0,
        priceF: 0,
        priceP: 0,
        priceG: 0,
      },
      rules: {
        feeName: [{ required: true, message: "必填项", trigger: "blur" }],
        companyId: [{ required: true, message: "必填项", trigger: "blur" }],
        fee1: [{ required: true, message: "必填项", trigger: "blur" }],
        fee2: [{ required: true, message: "必填项", trigger: "blur" }],
        fee3: [{ required: true, message: "必填项", trigger: "blur" }],
        fee4: [{ required: true, message: "必填项", trigger: "blur" }],
        fee5: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      id: 0,
    };
  },
  methods: {
    //初始化数据
    initData: function () {
      this.id = this.$route.query.id || null;
      let type = this.$route.query.type || null;
      let add = this.$route.query.add || null;
      if (type == "look") {
        this.disabled1 = true;
      } else {
        this.disabled1 = false;
      }
      if (add == "add") {
        this.disabled2 = true;
      } else {
        this.disabled2 = false;
      }
      let _this = this; //当前页面
      AxiosAjax({
        url: "/calculation/region",
        success: function (res) {
          if (res.data.code == 200) {
            _this.companyList = res.data.data;
          }
        },
      });
      if (this.id != null) {
        _this.model.regionId = _this.id;
        _this.disabled = true;
        AxiosAjax({
          url: "/calculation/price?regionId=" + _this.id,
          success: function (res) {
            if (res.data.code == 200) {
              _this.time.push(res.data.data.priceStartTime);
              _this.time.push(res.data.data.priceEndTime);
              _this.model.priceJ = res.data.data.priceJ;
              _this.model.priceF = res.data.data.priceF;
              _this.model.priceP = res.data.data.priceP;
              _this.model.priceG = res.data.data.priceG;
            }
          },
        });
      }
    },
    submitForms() {
      this.$router.push({
        name: "CalculationEditTime",
        query: { id: this.model.regionId },
      });
    },
    submitForm: function () {
      let _this = this; //当前页面
      //   多个表单验证;
      const f1 = new Promise((resolve, reject) => {
        _this.$refs["editForm1"].validate((valid) => {
          if (valid) resolve();
        });
      });
      _this.model.priceStartTime = _this.formatDateTo24Hour(_this.time[0]);
      _this.model.priceEndTime = _this.formatDateTo24Hour(_this.time[1]);
      AxiosAjax({
        url: "/calculation/price",
        method: "post",
        data: _this.model,
        success: function (res) {
          if (res.data.code == 200) {
            _this.$router.push({
              name: "CalculationEditTime",
              query: { id: _this.model.regionId },
            });
          }
        },
      });
    },
    resetForm() {
      window.history.back(-1);
    },
    formatDateTo24Hour(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    setCompanyId: function (obj) {
      this.model.companyId = obj.toString();
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
  mounted: function () {},
};
</script>
<style scoped>
.dl-box-fee .el-input {
  width: 20%;
}
.dl-box-fee /deep/ .el-form-item__label {
  min-width: 80px;
}
.dl-box .el-form-item__label {
  font-weight: bold;
}
.el-date-editor.el-input {
  width: 150px;
}
.myselect .el-input {
  width: 100px;
}
.card-form {
  display: flex;
}
.card-form /deep/ .el-col {
  flex: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/Calculation/CalculationEdit.vue